<template>
  <div data-component="ApiExplorer">
    <div class="api-explorer-container">
      <h1>API Explorer</h1>
      <p>Interface REST API pour les développeurs</p>
      <!-- L'interface API Explorer sera implémentée ici -->
      <div class="placeholder">
        <p>API REST interface à implémenter</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ApiExplorerView',
  mounted() {
    // Initialisation de l'API Explorer
  }
}
</script>

<style lang="scss" scoped>
@import './ApiExplorer.scss';
</style>
